import React from 'react';

const IconRecoverableError = () => (
  <svg width="152" height="152" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <g transform="translate(1 1)">
        <path
          d="M138.404 147.895l9.536-9.54a6.852 6.852 0 000-9.797L76.328 57 57 76.268l71.526 71.627a6.846 6.846 0 009.878 0z"
          stroke="#4A464A"
          fill="#A2D9F5"
        />
        <path
          d="M106.376 112L140 145.954l-2.205 2.23A5.95 5.95 0 01133.52 150a5.95 5.95 0 01-4.273-1.816L100 118.518l6.376-6.518z"
          fill="#6EC2EC"
        />
        <path
          d="M138.404 147.895l9.536-9.54a6.852 6.852 0 000-9.797L76.328 57 57 76.268l71.526 71.627a6.846 6.846 0 009.878 0z"
          stroke="#4A464A"
        />
        <path stroke="#FFF" fill="#16AEE5" d="M118 124l-10-10M127 133l6 6M140 133l-26-26" />
        <path
          stroke="#4A464A"
          fill="#FFF"
          d="M87.705 106.56l19.286-19.287 12.91 12.91-19.287 19.286z"
        />
        <path fill="#D3CFD0" d="M87.708 106.552l6.424-6.425 12.91 12.91-6.425 6.424z" />
        <path stroke="#4A464A" d="M87.705 106.56l19.286-19.287 12.91 12.91-19.287 19.286z" />
        <circle stroke="#4A464A" fill="#FFF" cx="58" cy="58" r="58" />
        <circle stroke="#4A464A" cx="58" cy="58" r="58" />
        <path
          d="M23.507 24C5.235 43.021 5.539 73.167 24.19 91.816c18.651 18.65 48.794 18.946 67.809.667M35 15a45.403 45.403 0 00-4 3"
          stroke="#EB6824"
          strokeLinecap="square"
        />
        <path d="M100 82a48.755 48.755 0 004-10" stroke="#EB6824" />
      </g>
      <path
        d="M75.252 44.858L62.524 57.585l12.728 12.729-2.829 2.828-12.727-12.728-12.729 12.728-2.828-2.828 12.729-12.729-12.729-12.727 2.828-2.828 12.729 12.727L72.423 42.03l2.829 2.828z"
        fill="#FA6400"
      />
    </g>
  </svg>
);

export default IconRecoverableError;
